import {Record} from 'immutable';
import {ReduceStore} from 'flux/utils';
import ActionTypes from '../ActionTypes';
import AppDispatcher from '../AppDispatcher';

const State = new Record({
  abertos: [],
  cpfClienteCaixa: '',
  idClienteCaixa: '',
  showQrPreviewCaixa: false,
  selecionada: null,
  lastOrder: null,
  pagamentos: [],
  payment: [],
  total: 0,
  pedidoEditavel: false,
    descontosEditadosCaixa: {},
  confirm: false,
  onConfirm() {},
  onCancel: null,
  title: '',
  text: '',
});

function orderAmount(order, descontosEditados) {
  if (!order)
    return 0;
  const itens = order.items;
  const desconto = (product) => descontosEditados[product.id_produto] || product.desconto;
  return itens.map(i => (i.quantidade * i.preco) - desconto(i)).reduce((a, b) => a + b, 0);
}

function cpf(order) {
    return !order ? '' : order.cpf;
}

class LojaCaixaStore extends ReduceStore {
    constructor() {
        super(AppDispatcher);
    }

    getInitialState() {
        return new State();
    }

    reduce(state, action) {
        switch (action.type) {
            case ActionTypes.UPDATE_TOKEN_FAILED:
            case ActionTypes.LOGOUT:
                return state.clear();

            case ActionTypes.LIST_OPEN_ORDERS_FINISH:
                let result = state.set('abertos', action.itens);
                if (state.selecionada) {
                    const selecionada = result.abertos.find(o => o.id == state.selecionada.id);
                    result = result
                      .set('selecionada', selecionada)
                      .set('total', orderAmount(selecionada, result.descontosEditadosCaixa))
                      .set('cpfClienteCaixa', cpf(selecionada));
                }
                if (state.payment.length === 1) {
                    const payment = state.payment.slice();
                    payment[0].valor = result.total;
                    result = result
                        .set('payment', payment);
                }
                return result;

            case ActionTypes.DELETE_CART_FINISH:
                if (state.selecionada && state.selecionada.id == action.id) {
                  return state
                      .set('selecionada', null)
                      .set('pagamentos', [])
                      .set('cpfClienteCaixa', '')
                      .set('payment', [])
                      .set('total', 0);
                }
                return state;

            case ActionTypes.SELECT_OPEN_ORDER:
                const selecionada = state.abertos.find(o => o.id == action.orderId);
                return state
                    .set('selecionada', selecionada)
                    .set('total', orderAmount(selecionada, state.descontosEditadosCaixa))
                    .set('cpfClienteCaixa', cpf(selecionada))
                    .set('pedidoEditavel', false)
                    .set('showQrPreviewCaixa', false)
                    .set('idClienteCaixa', '')
                    .set('payment', []);

            case ActionTypes.LIST_PAYMENT_METHODS_FINISH:
                return state
                    .set('pagamentos', action.methods);

            case ActionTypes.UPDATE_PAYMENT_SPLIT:
                return state
                    .set('payment', action.payment);

            case ActionTypes.UPDATE_TEXT:
                if (action.field === 'cpfClienteCaixa')
                    return state.set('cpfClienteCaixa', action.value);
                if (action.field === 'idClienteCaixa')
                    return state.set('idClienteCaixa', action.value);
                if (action.field === 'showQrPreviewCaixa')
                    return state.set('showQrPreviewCaixa', action.value);
                if (action.field === 'pedidoEditavel')
                    return state.set('pedidoEditavel', action.value);
                if (action.field === 'descontosEditadosCaixa') {
                    return state
                        .set('descontosEditadosCaixa', action.value)
                        .set('total', orderAmount(state.selecionada, action.value));
                }
                return state;

            case ActionTypes.SHOW_SWAL:
                return state
                    .set('confirm', true)
                    .set('title', action.title)
                    .set('text', action.text)
                    .set('onConfirm', action.onConfirm)
                    .set('onCancel', action.onCancel);

            case ActionTypes.CLOSE_SWAL:
                return state
                    .set('confirm', false)
                    .set('title', '')
                    .set('text', '')
                    .set('onConfirm', () => {})
                    .set('onCancel', null);

            case ActionTypes.CLOSE_ORDER_FINISH:
                return state
                    .set('lastOrder', state.abertos.find(o => o.id === action.orderId));

            default:
                return state;
        }
    }
}

export default new LojaCaixaStore();



// WEBPACK FOOTER //
// src/stores/LojaCaixaStore.js